import { render, staticRenderFns } from "./FileSignatureButton.vue?vue&type=template&id=db0bbfb4"
import script from "./FileSignatureButton.vue?vue&type=script&lang=ts"
export * from "./FileSignatureButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports